import React from 'react';
import { Sparkles } from 'lucide-react';

const BRAND_ORANGE = '#F47518';

const ACRONYMS = new Set(['PDF', 'PO', 'ATS', 'SME', 'B2B']);

function formatBadgeLabel(label) {
  if (!label) return '';
  return label
    .split(' ')
    .map((word) => {
      if (word === '&') return word;
      if (ACRONYMS.has(word)) return word;
      return word.charAt(0) + word.slice(1).toLowerCase();
    })
    .join(' ');
}

export default function ToolPageLabel({ label, exploreAction = 'generate' }) {
  if (!label) return null;

  return (
    <div
      className="flex items-center gap-3 mb-3"
      data-testid="tool-page-label-row"
    >
      <span
        className="w-fit whitespace-nowrap"
        style={{
          background: BRAND_ORANGE,
          color: '#ffffff',
          fontSize: '15px',
          fontWeight: 700,
          letterSpacing: '0.04em',
          padding: '8px 20px',
          borderRadius: '20px',
        }}
        data-testid="tool-page-label"
      >
        {formatBadgeLabel(label)}
      </span>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary whitespace-nowrap">
        <Sparkles className="h-3.5 w-3.5 shrink-0" />
        Free to explore — sign in to {exploreAction}
      </span>
    </div>
  );
}
